import styled from 'styled-components';
export const ListWrapper = styled.div `
  display: flex;
  position: relative;
  margin: -12px 0;
  p {
    margin-left: 10px;
  }
`;
//# sourceMappingURL=styles.js.map